/**
 * Internal dependencies
 */
import * as focusable from './focusable';
import * as tabbable from './tabbable';
/**
 * Object grouping `focusable` and `tabbable` utils
 * under the keys with the same name.
 */

export var focus = {
  focusable: focusable,
  tabbable: tabbable
};
export * from './dom';
//# sourceMappingURL=index.js.map